import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import './Payment.css';

const Payment = () => {
  const [searchParams] = useSearchParams();
  const [phone, setPhone] = useState('');
  const [amount, setAmount] = useState('');
  const [description, setDescription] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState('');

  useEffect(() => {
    const amt = searchParams.get('amount');
    const desc = searchParams.get('description');

    setAmount(amt || '');
    setDescription(desc || '');
  }, [searchParams]);

  const validatePhone = (phone) => {
    const sanitized = phone.replace(/\D/g, '');
    return /^2547\d{8}$/.test(sanitized);
  };

  const handleSubmit = async (e) => {
      e.preventDefault();
      setError('');
      setSuccessMsg('');

      const sanitizedPhone = phone.replace(/\D/g, '');

      if (!validatePhone(sanitizedPhone)) {
        setError('Please enter a valid Safaricom MPESA number (format: 2547XXXXXXXX)');
        return;
      }

      if (!amount || isNaN(amount) || Number(amount) < 10) {
        setError('Please enter a valid payment amount (minimum KES 10)');
        return;
      }

      setIsLoading(true);

      try {
        const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
        const response = await fetch(`${API_BASE_URL}/payment/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            phone: sanitizedPhone,
            amount: Number(amount),
            description
          })
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.error || 'Payment failed.');
        }

        setSuccessMsg(`An STK Push has been sent to ${sanitizedPhone}. Complete the payment on your phone.`);
        setPhone('');
      } catch (err) {
        setError(err.message || 'Something went wrong while processing payment.');
      } finally {
        setIsLoading(false);
      }
    };


  return (
    <div className="payment-container">
      <h1>Complete Your Payment</h1>

      <form onSubmit={handleSubmit} className="payment-form">
        <div className="form-group">
          <label htmlFor="amount">Amount (KES) *</label>
          <input
            type="number"
            id="amount"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            required
            placeholder="e.g. 5000"
            className={error ? 'error' : ''}
          />
        </div>

        <div className="form-group">
          <label htmlFor="description">Payment Description</label>
          <input
            type="text"
            id="description"
            value={decodeURIComponent(description)}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Project or service reference"
          />
        </div>

        <div className="form-group">
          <label htmlFor="phone">MPESA Phone Number (format: 2547XXXXXXXX) *</label>
          <input
            type="tel"
            id="phone"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            required
            placeholder="254712345678"
            className={error ? 'error' : ''}
          />
        </div>

        {error && <div className="field-error">{error}</div>}
        {successMsg && <div className="success-msg">{successMsg}</div>}

        <button type="submit" className="submit-btn" disabled={isLoading}>
          {isLoading ? (
            <>
              <div className="loading-spinner"></div>
              Sending STK Push...
            </>
          ) : (
            'Pay Now via MPESA'
          )}
        </button>
      </form>
    </div>
  );
};

export default Payment;
